import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root',
})
export class MaintenanceManager {
    calculate(resp) {
        let data = [];
        let unity_id = -1;
        let order_id = -1;
        let info = [];
        let quantity = 0;
        let total = 0;
        let totalPrice = 0;
        let totalDiscount = 0;

        if (resp.length) {
          info.push(resp[0]);
          unity_id = resp[0].unity_id;
          order_id = resp[0].id;
          quantity = Number(resp[0].quantity);
          total = Number(resp[0].quantity) * ( 1 + Number(resp[0].iva)) * Number(resp[0].price);
          totalPrice = Number(resp[0].quantity) * Number(resp[0].price);
          totalDiscount += Number(resp[0].discount);
          resp[0].lines = resp.filter(r => r.id == resp[0].id).length;

          for (let i = 1; i < resp.length; i++) {
            let element = resp[i];
            resp[i].lines = resp.filter(r => r.id == resp[i].id).length;

            if (element.unity_id != unity_id) {
              data.push({info, quantity, total, totalDiscount, totalTotal: total - totalDiscount, totalPrice});
              info = [];
              quantity = 0;
              total = 0;
              totalPrice = 0;
              totalDiscount = 0;
              unity_id = element.unity_id;
            }
            quantity += Number(element.quantity);
            total += Number(element.quantity) * ( 1 + Number(element.iva)) * Number(element.price);
            totalPrice += Number(element.quantity) * Number(element.price);
            if (element.id != order_id) {
              order_id = element.id;
              totalDiscount += Number(element.discount);
            }

            info.push(element);
          }

          data.push({info, quantity, total, totalDiscount, totalTotal: total - totalDiscount, totalPrice});
        }

        return data;
    }
}